module.exports = __webpack_public_path__ + "img/undraw_mindfulness_scgo.f405e9cf.svg";